/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SkippedInputs */

const cs_enum_skipped = /** @type {(inputs: Enum_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeskočeno`)
};

const en_enum_skipped = /** @type {(inputs: Enum_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skipped`)
};

/**
* | output |
* | --- |
* | "Skipped" |
*
* @param {Enum_SkippedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_skipped = /** @type {((inputs?: Enum_SkippedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SkippedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_skipped(inputs)
	return cs_enum_skipped(inputs)
});